'use strict';

function postLoginHandling() {
    if (sessionStorage.getItem('showLoginConsent') !== 'true') {
        return;
    }

    // Prevent it from running again on future page loads
    sessionStorage.removeItem('showLoginConsent');

    $.ajax({
        url: window.SFRA.Urls.setIAgreeLoginConsent,
        type: 'GET',
        dataType: 'json',
        success: function(data) {
        },
        error: function(e) {
            console.log(e);
        }
    });
}

postLoginHandling();